import * as htmlToImage from "html-to-image";

export async function captureComparisonImage(ref) {
  if (!ref?.current) {
    throw new Error("Comparison ref not found");
  }

  try {
    const dataUrl = await htmlToImage.toPng(ref.current, {
      backgroundColor: "#ffffff",
      pixelRatio: 2,
      cacheBust: true,
    });

    return dataUrl;
  } catch (error) {
    console.error("Error generating image:", error);
    throw error;
  }
}
